import React, { useRef, useState, Fragment } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import keys from '../../utils/keys';
import useClickOutside from '../../react-hooks/use-click-outside';

function ProgramResultCard({
  ProgramGroupingName: programGroupingName,
  ProgramGroupingDescription: programGroupingDescription,
  ListPrograms: listPrograms
}) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  function modalRender() {
    if (!isOpen) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }
  function handleKeyDown(e) {
    e.preventDefault();
    if (e.keyCode === keys.escape) {
      setIsOpen(false);
    }
  }

  useClickOutside(containerRef, () => modalRender());



  return (
    <Fragment>
      <button onClick={modalRender} className='program-listing-result-card'>
        <div className='program-listing-result-card__container'>
          <p className='program-listing-result-card__name'>{programGroupingName}</p>
          <div className='program-listing-result-card__tooltip__icon' />
        </div>
      </button>
      <div className='modal'>
        {isOpen && (
          <div className='program-group-modal__backdrop'>
            <div
              ref={containerRef}
              className='program-group-modal__container'
              role='dialog'
            >
              <header>
                <p className='program-group-modal__name'>{programGroupingName}</p>
                <button autoFocus onKeyDown={(e) => handleKeyDown(e)} className='program-group-modal__close-button' aria-label='Close modal' onClick={modalRender}>
                  <svg>
                    <use href='#close-outline-light' />
                  </svg>
                </button>
              </header>
              {programGroupingDescription && (
                <div className='program-group-modal__description'>
                  {programGroupingDescription}
                </div>)}
              <div className='program-group-modal__subtitle'>Select a Degree</div>
              {listPrograms.map((option) => (
                <a key={option.Id} href={option.Url}>
                  <button className="btn--modal btn--white-modal">
                    <span>{option.Label}</span>
                  </button>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
}

ProgramResultCard.propTypes = {
  ProgramGroupingName: string.isRequired,
  ProgramGroupingDescription: string,
  ListPrograms: arrayOf(
    shape({
      Label: string.isRequired,
      Url: string.isRequired
    }).isRequired
  ).isRequired
};

export default React.memo(ProgramResultCard);
